import { S as o, q as r } from "./stale.constant.De1PuSBj.js";
import { useQuery as u } from "@tanstack/react-query";
import { g as l } from "./use-account.DkVfV1FC.js";
const i = (t) => u({
  queryKey: r.accountsRelationTypes,
  queryFn: l,
  staleTime: o,
  select: (s) => s.data.filter(({ value: e }) => e !== "SELF").map(({ value: e, relation: a }) => ({
    value: e,
    label: a
  })),
  enabled: t ?? !0
});
export {
  i as u
};
